import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import { TreeSpeciesRecord } from "../../../type/treeSpecies";
import useAxios from "../../../hook/useAxios";
import DeleteAlert from "../../ErrorAndAlert/DeleteAlert";
import ActionItem from "../../Global/ActionItem";
import { toast } from "react-toastify";

const SpeciesTableItem: React.FC<{
  speciesItem: TreeSpeciesRecord;
  fetchData: () => void;
  lastIndex: number;
}> = ({ speciesItem, lastIndex, fetchData: propFetchData }) => {
  const { t, i18n } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);

  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/species/${speciesItem.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.Successful delete")}`,
    true,
    true
  );

  useEffect(() => {
    if (deleteR) {
      propFetchData();
      isShowDelete(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (speciesItem.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(t("Message.Invalid species delete"));
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };
  const name =
    speciesItem.name_transes.fr === ""
      ? speciesItem.name_transes.en
      : speciesItem.name_transes.fr;
  const scientificName =
    speciesItem.scientific_name_transes.fr === ""
      ? speciesItem.scientific_name_transes.en
      : speciesItem.scientific_name_transes.fr;
  const botanicalFamily =
    speciesItem.botanical_family_transes?.fr === ""
      ? speciesItem.botanical_family_transes?.en
      : speciesItem.botanical_family_transes?.fr;
  const type =
    speciesItem.type_transes.fr === ""
      ? speciesItem.type_transes.en
      : speciesItem.type_transes.fr;
  const abundance =
    speciesItem.abundance_transes.fr === ""
      ? speciesItem.abundance_transes.en
      : speciesItem.abundance_transes.fr;
  const active =
    i18n.language === "en"
      ? speciesItem.is_active_transes.en
      : speciesItem.is_active_transes.fr;
  return (
    <Fragment>
      <TableCell align="left">
        {i18n.language === "fr" ? name : speciesItem.name_transes.en}
      </TableCell>
      <TableCell align="left">
        {i18n.language === "fr"
          ? scientificName
          : speciesItem.scientific_name_transes.en}
      </TableCell>
      <TableCell align="left">
        {i18n.language === "fr"
          ? botanicalFamily
          : speciesItem.botanical_family_transes?.en}
      </TableCell>
      <TableCell align="left">
        {i18n.language === "fr" ? type : speciesItem.type_transes.en}
      </TableCell>
      <TableCell align="left">
        {i18n.language === "fr" ? abundance : speciesItem.abundance_transes.en}
      </TableCell>
      <TableCell>
        <p
          className={`${
            speciesItem.is_active_transes.en === "Active"
              ? "bg-ph-toggle-bg-green text-ph-toggle-text-green"
              : "bg-ph-toggle-bg-red text-ph-red-warning"
          } text-center w-16 py-1 rounded-xl`}
        >
          {active}
        </p>
      </TableCell>
      <TableCell align="right">
        <ActionItem
          delete={true}
          deleteAction={deleteAction}
          editLink={`/setting/tree-species/edit-species/${speciesItem.slug}`}
          view=""
          viewLink=""
          historyLink=""
          viewHistory=""
        />
      </TableCell>
      {showDelete && (
        <DeleteAlert
          type={t("Tree Species.Tree species")}
          hide={hide}
          deleteAction={deleteItem}
        />
      )}
    </Fragment>
  );
};

export default SpeciesTableItem;
